import React, { useState, useEffect, useReducer } from "react"
import { connect } from "react-redux"
import * as XLSX from 'xlsx'
import { saveAs } from 'file-saver'

import {
  Table,
  Input,
  Button,
  Row,
  Col,
  Form,
  Popconfirm,
  Card,
  Space,
  Typography,
  Statistic,
  Tooltip,
  Tag,
  Collapse,
  Alert,
  Spin,
} from "antd"
import { columns } from "./columns"
import { PersianDatePickerInline } from "components/Common/PersianDatePickerInline"
import {
  engPaymentApproved,
  getEngPaymentList,
  getEngPaymentTask,
  getListEngineer,
  resetEngPaymentListFlag,
  updateEngPaymentList,
  upsertEngPaymentList,
} from "store/actions"
import { withTranslation } from "react-i18next"
import { serializeQuery } from "helpers/service_helper"
import { EngPaymentTaskList } from "./eng-payment-task-list"
import { ListEngineerMultiple } from "./ListEngineerMultiple"
import {
  SaveOutlined,
  SearchOutlined,
  FilterOutlined,
  BankOutlined,
  FileExcelOutlined,
  CalculatorOutlined,
  CalendarOutlined,
  ReloadOutlined,
  TeamOutlined,
  CheckCircleOutlined,
} from "@ant-design/icons"

const { Title, Text } = Typography
const { Panel } = Collapse

const EngPaymentList = props => {
  const {
    lstEngPayment,
    loading,
    onGetEngPaymentList,
    onUpsertEngPaymentList,
    openNotification,
    onResetEngPaymentListFlag,
    lstEngPaymentTask,
    reload,
    lstEngineer,
    onGetListEngineer,
  } = props
  const [form] = Form.useForm()

  const [errorMessage, setErrorMessage] = useState(null)
  const [formInput, setFormInput] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      period: 1,
    }
  )
  const [fromSolar, setFromSolar] = useState("")
  const [toSolar, setToSolar] = useState("")
  const [solarApproved, setSolarApproved] = useState("")
  const [countChangeFormInput, setCountChangeFormInput] = useState(0)
  const [engPaymentTaskId, setEngPaymentTaskId] = useState(null)
  const [selectedEngineerIds, setSelectedEngineerIds] = useState([])

  // محاسبه آمار پرداخت
  const calculateStats = () => {
    if (!lstEngPayment || lstEngPayment.length === 0) {
      return {
        totalCount: 0,
        totalAmount: 0,
        bankAmount: 0,
        fishAmount: 0,
        bankCount: 0,
        fishCount: 0,
      }
    }

    let bankAmount = 0
    let fishAmount = 0
    let bankCount = 0
    let fishCount = 0

    lstEngPayment.forEach(x => {
      if (!x.payByBankReceipt) {
        bankAmount += x.sumAmountWithFish
        bankCount++
      } else {
        fishAmount += x.sumAmountWithFish
        fishCount++
      }
    })

    return {
      totalCount: lstEngPayment.length,
      totalAmount: bankAmount + fishAmount,
      bankAmount,
      fishAmount,
      bankCount,
      fishCount,
    }
  }

  const stats = calculateStats()

  const formatNumber = num => {
    return String(num).replace(/\B(?=(\d{3})+(?!\d))/g, ",")
  }

  const handleInput = evt => {
    const name = evt.target.name
    const newValue = evt.target.value
    setFormInput({ [name]: newValue })
    setCountChangeFormInput(prev => prev + 1)
  }

  const onChange = (pagination, filters, sorter, extra) => {
    console.log("params", pagination, filters, sorter, extra)
  }

  useEffect(async () => {
    if (props.success) openNotification("success", "top", props.success)
    if (props.error) openNotification("error", "top", props.error)
    if (errorMessage) openNotification("warning", "top", errorMessage)
    onResetEngPaymentListFlag()
  }, [errorMessage, props.success, props.error])

  useEffect(async () => {
    await handleSearchSupports()
  }, [])

  useEffect(async () => {
    if (reload) {
      await handleSearchSupports()
    }
    if (countChangeFormInput) {
      await handleSearchSupports()
    }
    if (engPaymentTaskId) {
      await handleSearchSupports()
    }
  }, [reload, countChangeFormInput, engPaymentTaskId])

  const handleSubmit = values => {
    let searchQuery = {
      engPaymentTaskId: engPaymentTaskId ? engPaymentTaskId : "",
    }
    const params = serializeQuery(searchQuery)

    let updatedData = {
      ...values,
      fromSolar: fromSolar.persian,
      toSolar: toSolar.persian,
    }
    delete updatedData.period
    // delete updatedData.julianMembershipDate
    onUpsertEngPaymentList({ updatedData, params })
    form.resetFields()
  }

  const handleSearchSupports = async val => {
    let searchQuery = {
      engPaymentTaskId,
    }

    // فقط وقتی مهندس انتخاب شده باشد، پارامتر engineerIds اضافه شود
    if (selectedEngineerIds.length > 0) {
      searchQuery.engineerIds = selectedEngineerIds.join(',')
    }

    const params = serializeQuery(searchQuery)
    if (!!engPaymentTaskId) onGetEngPaymentList(params)
  }
  // Function to handle edit button click
  const handleEdit = record => {
    // form.setFieldsValue(record)
    // // setSolarBirthDate(record.solarBirthDate)
    // setEditingId(record.id)
  }

  const handleApproved = () => {
    const { onEngPaymentApproved } = props
    if (engPaymentTaskId && solarApproved) {
      onEngPaymentApproved({
        engPaymentTaskId,
        solarApproved: solarApproved.persian,
      })
    } else {
      setErrorMessage("تاریخ پرداخت بانکی را انتخاب کنید")
    }
  }

  function pad(n, len) {
    return (new Array(len + 1).join("0") + n).slice(-len)
  }
  const exportToBankFile = () => {
    let lines = ""

    const listPayments = lstEngPayment
    listPayments.forEach(element => {

      let bankAccount = element.engineer.bankAccountNumber?.trim().replace(/[^a-zA-Z0-9]/g, '')
      if(bankAccount.length === 8) bankAccount = "100" + bankAccount
      if(bankAccount.length === 9) bankAccount = "10" + bankAccount
      if(bankAccount.length === 10) bankAccount = "1" + bankAccount
      const line = bankAccount + element.sumAmountWithFish
      const countChar = line.length
      const countZero = 25 - countChar
      let resultLine =  bankAccount + pad("0", +countZero) + element.sumAmountWithFish

      if (countZero <= 0) {
        openNotification("error", "top", "خطای 25 کاراکتری")
        resultLine = "خطای 25 کاراکتری"
      }
      if(resultLine.length != 25) {
        openNotification("error", "top", "خطای 25 کاراکتری")
        resultLine = `"خطای 25 کاراکتری" : ${element.engineer.fullName}`

      }
      if(!element.engineer.bankAccountNumber) {
        openNotification("error", "top", `خطا در شماره حساب یا مبلغ : ${element.engineer.fullName}`)
        resultLine = `خطا در شماره حساب یا مبلغ : ${element.engineer.fullName}`
      }
      if(element.payByBankReceipt) return
      lines =
        lines + resultLine
        +
        "\r\n"
        
    })
    const task = lstEngPaymentTask.find(x=>x.id === engPaymentTaskId)
    const blob = new Blob([lines], { type: "text/plain;charset=utf-8" })
    saveAs(blob, `${'خروجی بانک' + "_" + task.solarCreated.replaceAll("/","_").split("_").reverse().join("_")}.txt`)
  }

  const showToPay = () => {
    const { bankAmount, fishAmount, totalAmount } = stats
    alert(
      `مبلغ پرداخت چک به بانک: ${formatNumber(bankAmount)} ریال\n` +
      `مبلغ پرداخت فیش دستی: ${formatNumber(fishAmount)} ریال\n` +
      `مبلغ کل پرداختی: ${formatNumber(totalAmount)} ریال`
    )
  }
  const convertToExcel = () => {
    
    const MYdata = lstEngPayment.map(x=> ({
      'ردیف': x.sortIndex,
      'نام و نام خانوادگی': x.fullName,
      'مبلغ سیستمی':x.amountSystem,
      'فیش کاغذی':x.addition1,
      'جمع سیستمی و کاغذی':x.amountSystem + x.addition1,
      'کسورات':x.deduction1,
      '90.5 درصد':x.amountSystem + x.addition1 - x.deduction1,
      'کسورات بیمه':x.deduction2,
      'کسولات علی الحساب':x.deduction3,
      'سایر کسورات':x.deduction4,
      'خالص پرداختی':x.sumAmountWithFish,
      'پرداخت با فیش':x.payByBankReceipt?'بله': 'خیر',
      "شماره حساب": x.engineer.bankAccountNumber
    }))
    const worksheet = XLSX.utils.json_to_sheet(MYdata);
    const workbook = XLSX.utils.book_new();
    const task = lstEngPaymentTask.find(x=>x.id === engPaymentTaskId)
    const label = "لیست پرداختی دوره:" + task.period

    XLSX.utils.book_append_sheet(workbook, worksheet, `پرداختی دوره ${task.period}`)
    XLSX.writeFile(workbook, `${label + "_" + task.solarCreated.replaceAll("/", "_").split("_").reverse().join("_")}.xlsx`)
  }

  // کارت آمار
  const StatCard = ({ title, value, icon, color, suffix }) => (
    <Card
      size="small"
      style={{
        borderRadius: 12,
        boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
        border: `1px solid ${color}20`,
        background: `linear-gradient(135deg, ${color}08 0%, white 100%)`,
      }}
    >
      <Statistic
        title={<Text style={{ color: '#666', fontSize: 12 }}>{title}</Text>}
        value={value}
        suffix={suffix}
        prefix={icon}
        valueStyle={{ color, fontSize: 18, fontWeight: 600 }}
      />
    </Card>
  )

  return (
    <div style={{ padding: '16px', background: '#f5f7fa', minHeight: '100vh' }}>
      {/* هدر */}
      <Card
        style={{
          marginBottom: 16,
          borderRadius: 12,
          boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
        }}
      >
        <Row justify="space-between" align="middle">
          <Col>
            <Space>
              <Title level={4} style={{ margin: 0 }}>مدیریت پرداخت مهندسین</Title>
            </Space>
          </Col>
          <Col>
            <Space>
              <Button
                icon={<ReloadOutlined />}
                onClick={() => handleSearchSupports()}
                loading={loading}
              >
                بروزرسانی
              </Button>
            </Space>
          </Col>
        </Row>
      </Card>

      {/* آمار کلی */}
      {lstEngPayment && lstEngPayment.length > 0 && (
        <Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
          <Col xs={24} sm={12} md={6}>
            <StatCard
              title="تعداد کل مهندسین"
              value={stats.totalCount}
              icon={<TeamOutlined />}
              color="#1890ff"
              suffix="نفر"
            />
          </Col>
          <Col xs={24} sm={12} md={6}>
            <StatCard
              title="مجموع پرداختی"
              value={formatNumber(stats.totalAmount)}
              color="#52c41a"
              suffix="ریال"
            />
          </Col>
          <Col xs={24} sm={12} md={6}>
            <StatCard
              title="پرداخت بانکی"
              value={formatNumber(stats.bankAmount)}
              icon={<BankOutlined />}
              color="#722ed1"
              suffix={`(${stats.bankCount} نفر)`}
            />
          </Col>
          <Col xs={24} sm={12} md={6}>
            <StatCard
              title="پرداخت فیش"
              value={formatNumber(stats.fishAmount)}
              icon={<CheckCircleOutlined />}
              color="#fa8c16"
              suffix={`(${stats.fishCount} نفر)`}
            />
          </Col>
        </Row>
      )}

      {/* فیلترها */}
      <Collapse
        defaultActiveKey={['filters']}
        style={{
          marginBottom: 16,
          borderRadius: 12,
          overflow: 'hidden',
          boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
        }}
      >
        <Panel
          header={
            <Space>
              <FilterOutlined style={{ color: '#1890ff' }} />
              <Text strong>فیلتر و جستجو</Text>
              {selectedEngineerIds.length > 0 && (
                <Tag color="blue">{selectedEngineerIds.length} مهندس انتخاب شده</Tag>
              )}
            </Space>
          }
          key="filters"
        >
          {/* انتخاب دوره پرداخت */}
          <Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
            <Col span={24}>
              <Card
                size="small"
                title={<><CalendarOutlined /> انتخاب دوره پرداخت</>}
                style={{ borderRadius: 8 }}
              >
                <Row gutter={[16, 8]} align="middle">
                  <Col xs={24} md={18}>
                    <EngPaymentTaskList
                      selectEngPaymentTask={setEngPaymentTaskId}
                      props={props}
                    />
                  </Col>
                  <Col xs={24} md={6}>
                    <Button
                      type="primary"
                      icon={<SearchOutlined />}
                      onClick={() => handleSearchSupports()}
                      block
                      loading={loading}
                    >
                      جستجو
                    </Button>
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>

          {/* فیلتر مهندسین */}
          <Row gutter={[16, 16]}>
            <Col span={24}>
              <Card
                size="small"
                title={<><TeamOutlined /> فیلتر مهندسین</>}
                style={{ borderRadius: 8 }}
              >
                <ListEngineerMultiple
                  props={{ lstEngineer, onGetListEngineer }}
                  selectEngineers={setSelectedEngineerIds}
                  selectedEngineers={selectedEngineerIds}
                />
              </Card>
            </Col>
          </Row>
        </Panel>
      </Collapse>

      {/* جدول اصلی */}
      <Card
        style={{
          borderRadius: 12,
          marginBottom: 16,
          boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
        }}
        title={
          <Space>
            <Text strong>لیست پرداخت‌ها</Text>
            {lstEngPayment?.length > 0 && (
              <Tag color="blue">{lstEngPayment.length} رکورد</Tag>
            )}
          </Space>
        }
        extra={
          <Space>
            <Tooltip title="خروجی بانک">
              <Button
                type="primary"
                icon={<BankOutlined />}
                onClick={() => exportToBankFile()}
                disabled={!lstEngPayment?.length}
              >
                خروجی بانک
              </Button>
            </Tooltip>
            <Tooltip title="خروجی اکسل">
              <Button
                icon={<FileExcelOutlined />}
                onClick={() => convertToExcel()}
                disabled={!lstEngPayment?.length}
                style={{ color: '#52c41a', borderColor: '#52c41a' }}
              >
                خروجی اکسل
              </Button>
            </Tooltip>
            <Tooltip title="محاسبه پرداخت">
              <Button
                icon={<CalculatorOutlined />}
                onClick={() => showToPay()}
                disabled={!lstEngPayment?.length}
              >
                محاسبه
              </Button>
            </Tooltip>
          </Space>
        }
      >
        <Spin spinning={loading}>
          <Table
            size="small"
            pagination={{
              showSizeChanger: true,
              showQuickJumper: true,
              showTotal: (total, range) => `${range[0]}-${range[1]} از ${total} رکورد`,
              pageSizeOptions: ['10', '20', '50', '100'],
            }}
            scroll={{
              y: 500,
              x: 1200,
            }}
            sticky
            columns={columns({
              props,
              handleEdit,
              fullNameFilter: lstEngPayment?.map(x => ({
                text: x.fullName,
                value: x.fullName,
              })) || [],
            })}
            rowClassName={(_r, i) => (i % 2 ? "table-row-light" : "table-row-dark")}
            rowKey={record => record.id}
            dataSource={lstEngPayment}
            onChange={onChange}
            locale={{ emptyText: 'داده‌ای برای نمایش وجود ندارد' }}
          />
        </Spin>
      </Card>

      {/* فرم ثبت دوره جدید */}
      <Collapse
        style={{
          marginBottom: 16,
          borderRadius: 12,
          overflow: 'hidden',
          boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
        }}
      >
        <Panel
          header={
            <Space>
              <CalendarOutlined style={{ color: '#52c41a' }} />
              <Text strong>ثبت دوره جدید</Text>
            </Space>
          }
          key="new-period"
        >
          <Form name="engForm" form={form} onFinish={handleSubmit} layout="vertical">
            <Row gutter={[16, 16]}>
              <Col xs={24} sm={8}>
                <Form.Item required label="از تاریخ:" name="fromSolar">
                  <PersianDatePickerInline
                    defaultDate={form.getFieldValue("fromSolar")?.toString()?.substring(0, 10)}
                    setPersianDate={setFromSolar}
                    isPortal={true}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={8}>
                <Form.Item required label="تا تاریخ:" name="toSolar">
                  <PersianDatePickerInline
                    defaultDate={form.getFieldValue("toSolar")?.toString()?.substring(0, 10)}
                    setPersianDate={setToSolar}
                    isPortal={true}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={8}>
                <Form.Item label="توضیحات:" name="description">
                  <Input.TextArea rows={2} placeholder="توضیحات دوره پرداخت..." />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={[16, 16]}>
              <Col>
                <Button
                  disabled={loading}
                  type="primary"
                  htmlType="submit"
                  icon={<SaveOutlined />}
                >
                  ذخیره دوره
                </Button>
              </Col>
              <Col>
                <Button htmlType="button" onClick={() => form.resetFields()}>
                  پاک کردن فرم
                </Button>
              </Col>
            </Row>
          </Form>
        </Panel>
      </Collapse>

      {/* تایید پرداخت بانکی */}
      <Card
        style={{
          borderRadius: 12,
          boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
          border: '1px solid #d9f7be',
          background: 'linear-gradient(135deg, #f6ffed 0%, white 100%)',
        }}
        title={
          <Space>
            <BankOutlined style={{ color: '#52c41a' }} />
            <Text strong>تایید پرداخت بانکی</Text>
          </Space>
        }
      >
        <Alert
          message="توجه: پس از تایید پرداخت، امکان ویرایش وجود نخواهد داشت."
          type="warning"
          showIcon
          style={{ marginBottom: 16, borderRadius: 8 }}
        />
        <Row gutter={[16, 16]} align="middle">
          <Col xs={24} sm={12} md={8}>
            <PersianDatePickerInline
              label="تاریخ پرداخت بانکی:"
              setPersianDate={setSolarApproved}
              isPortal={true}
            />
          </Col>
          <Col>
            <Popconfirm
              title="تایید پرداخت"
              description="بعد از پرداخت قابل ویرایش نمی‌باشد. آیا مطمئن هستید؟"
              onConfirm={() => handleApproved()}
              okText="بله، تایید می‌کنم"
              cancelText="انصراف"
              okButtonProps={{ danger: true }}
            >
              <Button
                type="primary"
                danger
                icon={<CheckCircleOutlined />}
                size="large"
              >
                تایید نهایی پرداخت
              </Button>
            </Popconfirm>
          </Col>
        </Row>
      </Card>

      {/* استایل‌های اضافی */}
      <style>{`
        .table-row-light {
          background-color: #fafafa;
        }
        .table-row-dark {
          background-color: #ffffff;
        }
        .table-row-light:hover,
        .table-row-dark:hover {
          background-color: #e6f7ff !important;
        }
  
      `}</style>
    </div>
  )
}

const mapStateToProps = ({ EngPayment, Engineers }) => ({
  lstEngPayment: EngPayment.lstEngPayment,
  lstEngPaymentTask: EngPayment.lstEngPaymentTask,
  error: EngPayment.error,
  success: EngPayment.success,
  loading: EngPayment.loading,
  lstEngineer: Engineers.lstEngineer,
})

const mapDispatchToProps = dispatch => ({
  onGetEngPaymentList: searchValue => dispatch(getEngPaymentList(searchValue)),
  onGetEngPaymentTasks: () => dispatch(getEngPaymentTask()),
  onUpsertEngPaymentList: data => dispatch(upsertEngPaymentList(data)),
  onUpdateEngPaymentList: data => dispatch(updateEngPaymentList(data)),
  onResetEngPaymentListFlag: () => dispatch(resetEngPaymentListFlag()),
  onEngPaymentApproved: data => dispatch(engPaymentApproved(data)),
  onGetListEngineer: () => dispatch(getListEngineer()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(EngPaymentList))
